/* One risk's page. Tokens only (ADR-0007). No colour by score: a risk is marked by what needs doing
   (an overdue review, a rescoring owed), never by how bad the words say it is (RSK-01). */

/* The assessment is wider than the side panel: 8 of 12 columns on a wide screen, stacked below. */
.main {
  grid-column: 1 / 9;
  min-width: 0;
}

.side {
  grid-column: 9 / 13;
  min-width: 0;
}

@media (width <= 900px) {
  .main,
  .side {
    grid-column: 1;
  }
}

.score {
  margin: 0 0 6px;
  font-size: var(--t-body);
  font-weight: 600;
  color: var(--ink);
}

.description {
  margin: 0 0 12px;
  font-size: var(--t-min);
  line-height: 1.5;
  color: var(--ink-2);
  max-width: 80ch;
}

.kv {
  grid-template-columns: 120px minmax(0, 1fr);
}

.actions {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 10px;
}

.action {
  display: grid;
  gap: 3px;
  padding-bottom: 10px;
  border-bottom: 1px solid var(--line);
}

.action:last-child {
  border-bottom: 0;
  padding-bottom: 0;
}

.actionHead {
  display: flex;
  gap: 8px;
  align-items: baseline;
  flex-wrap: wrap;
}

.actionWhat {
  font-size: var(--t-dense);
  color: var(--ink);
}

.actionMeta {
  font-size: var(--t-min);
  color: var(--muted);
}
